module.exports = new __parcel__URL__("delivery.5049ed34.webp").toString();